import { Injectable } from '@angular/core';
import { FiltersService } from '@shared/services/filters/filters.service';

@Injectable()
export class ComponentDependencyJunctionService {
  private _filterService: FiltersService;

  private _inputElementRef: HTMLInputElement;

  get textSearchActive(): boolean {
    return this.hasValue && this._filterService?.hasSearch;
  }

  get hasValue(): boolean {
    return this._inputElementRef?.value !== '';
  }

  setElement(input: HTMLInputElement) {
    this._inputElementRef = input;
  }

  initFilterService(filterService: FiltersService) {
    this._filterService = filterService;
  }
}
